import { FormControlLabel, FormGroup, Typography, useTheme } from "@mui/material";
import CheckBox from "@mui/material/Checkbox";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";
import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spacer from "../utils/spacer.component";
import { getTerm, termSelector } from "../../services/term/term-slice.service";
import { SnackbarContext } from "../notification/snackbar.context";

function FormMerchantTncCheckbox({ setTnc, merchantSlug }) {
  const theme = useTheme();
  const { setFieldValue, values } = useFormikContext();
  const dispatch = useDispatch();
  const { getTermObj } = useSelector(termSelector);
  const createSnackBar = useContext(SnackbarContext);
  const handleOnChange = (event) => {
    setFieldValue("tnc", event.target.checked);
    setTnc(event.target.checked);
  };

  useEffect(() => {
    if (values.tnc === undefined) {
      setFieldValue("tnc", false);
    }

    dispatch(getTerm(merchantSlug)).then(({ meta, error, payload }) => {
      if (meta.requestStatus === "fulfilled") {
        if (payload.data.term) {
          setTnc(false);
        } else {
          setTnc(null);
        }
      }

      if (meta.requestStatus === "rejected") {
        createSnackBar({
          message: error.message,
          type: "error",
          open: true,
        });
      }
    });
  }, []);

  if (getTermObj.status === "succeeded" && getTermObj.data.term) {
    return (
      <FormGroup sx={{ marginTop: -0.7 }}>
        <FormControlLabel
          name="tnc"
          control={
            <CheckBox
              onChange={handleOnChange}
              size="small"
              sx={{
                color: !values.tnc
                  ? theme.palette.colors.ui.error
                  : theme.palette.colors.brand.primary,
                "&.Mui-checked": {
                  color: theme.palette.colors.brand.primary,
                },
              }}
            />
          }
          label={
            <Typography
              variant="body2"
              fontSize={theme.fonts.fontSizes.size12}
              sx={{
                color: !values.tnc
                  ? theme.palette.colors.ui.error
                  : theme.palette.colors.brand.primary,
              }}
            >
              By proceeding, you confirm that you have read and agree to the{" "}
              <a
                href={`/terms/${merchantSlug}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: theme.palette.colors.brand.primary }}
              >
                Merchant&apos;s Terms and Conditions
              </a>
              .
            </Typography>
          }
        />
        <Spacer size="l" />
      </FormGroup>
    );
  }

  return null;
}

FormMerchantTncCheckbox.propTypes = {
  setTnc: PropTypes.func.isRequired,
  merchantSlug: PropTypes.string.isRequired,
};

export default FormMerchantTncCheckbox;
